import React from 'react';

export const WhatIsInstaCash = [
	{
		id: 2,
		type: 'multicolumn',
		paragraphs: [
			{
				id: 11,
				paragraph: [
					<p>
						A commonplace practice is to park surplus funds in a Bank Fixed
						Deposit, while funds for daily/monthly activities are placed in
						savings/current accounts. However, there is an alternative that
						could provide higher returns with similar flexibility than that of
						Fixed Deposits – investing in liquid mutual funds i.e InstaCash.
					</p>,
					<p>
						Liquid mutual funds are that category of mutual funds that invest in
						debt instruments – for e.g. Commercial Papers, Treasury Bills,
						Government Securities, etc. These investments are short term in
						nature and can be withdrawn without any difficulty, which is why
						they are also called insta redemption funds.
					</p>,
				],
			},
			{
				id: 12,
				paragraph: [
					<p>
						While FD’s might call for a penalty if withdrawn prematurely, liquid
						funds can be redeemed without attracting any penalty in the form of
						an exit load if withdrawn after a mere 7-day period. If withdrawn
						before 7 days, a small amount of exit load is levied.
					</p>,
					<p>
						When it comes to taxation of this form of investment, if held for
						more than 3 years, they are eligible for long term capital gains
						with indexation. If redeemed before 3 years, tax is applicable as
						per investors tax slab. In case the investor opts for dividend
						option, the fund would be subject to a dividend distribution tax.
					</p>,
				],
			},
		],
	},
];
